import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { CartIcon, SubsIcon, ProductIcon } from "./table";
import { ArrowRightIcon } from "../../../icons";
import config from "constants/config";
import moment from "moment";
import Pagination from "../../../../../components/pagination";
import ClearFilters from "../../../../../components/table2/clear-filters";

const MobileProducts = ({ data, isAdmin, clearFilters, skipGateway }) => {

    let SIZE = 3;
    const [currentPage, setCurrentPage] = useState(1);
    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * SIZE;
        const lastPageIndex = firstPageIndex + SIZE;
        return data.slice(firstPageIndex, lastPageIndex);
    }, [currentPage, data]);

    if(!data.length) {
        if(clearFilters) {
            return <ClearFilters clearFilters={clearFilters} />
        }
        return null;
    }

    return (
        <div>
            {currentTableData.map((item, key) => {

                const { uniqid, type, customer_email, status_details, currency, created_at, crypto_amount, void_details, gateway, total_display, status } = item;

                let isFree = +total_display === 0;

                const s = config.ORDER_STATUS[status] || "";

                return <div className="table-mobile-card" key={key}>

                    <Link to={isAdmin ? `tools/invoices/${uniqid}` : `/invoices/${uniqid}`} className="table-mobile-card-header">
                        <div className="d-flex">
                            <div className="table-mobile-card-header-icon">
                                {type === 'SHOPPING_CART' ?
                                    <CartIcon /> :
                                    type === 'PRODUCT_SUBSCRIPTION' ?
                                        <SubsIcon /> :
                                        <ProductIcon />
                                }
                            </div>

                            <div className="table-mobile-card-header-main">
                                <Link to={isAdmin ? `tools/invoices/${uniqid}` : `/invoices/${uniqid}`} className="d-flex">{uniqid}</Link>
                                <div>{customer_email ? customer_email : moment(created_at * 1000).format('HH:mm DD MMM')}</div>
                            </div>
                        </div>
                        <ArrowRightIcon />
                    </Link>

                    <div className="table-mobile-card-body">
                        <div className="table-mobile-card-body-list">
                            {skipGateway ? null : <div><div>Gateway</div><div>{isFree || !gateway ? " - " :  <div className="d-flex align-items-center">
                                <img className="mr-2" style={{ width: 15, height: 15 }} src={config.PAYMENT_ICONS[gateway]} alt=""/> {config.PAYMENT_FULL_NAME[gateway]}
                            </div>}</div></div>}
                            <div><div>Value</div><div>{
                                isFree ?
                                <div className="d-flex flex-column">
                                    <span className="d-flex" />
                                    <span className="d-flex" style={{ fontWeight: 400, fontSize: 12, lineHeight: "15px", color: "var(--black4)" }}>Free</span>
                                </div>
                                    :
                                <div className="d-flex flex-column align-items-end">
                                    <span className="d-flex mb-1">{config.CURRENCY_LIST[currency]} {total_display}</span>
                                    <span style={{ fontWeight: 400, fontSize: 12, lineHeight: "15px", color: "var(--black4)" }} className="d-flex">{crypto_amount}</span>
                                </div>
                            }</div></div>
                            <div><div>Status</div><div><div className="d-flex justify-content-center">
                                {status === "VOIDED" && void_details === "PRODUCT_SOLD_OUT" && <span className="badge badge-cancelled ml-2">Product Sold Out</span>}
                                {status === "VOIDED" && void_details === "CART_PRODUCTS_SOLD_OUT" && <span className="badge badge-cancelled ml-2">Cart Products Sold Out</span>}
                                {status === "COMPLETED" && status_details === "CART_PARTIAL_OUT_OF_STOCK" && <span className="badge badge-cancelled ml-2">Cart Partial Out Of Stock</span>}
                                <div className={`badge badge-${(s || "").toLowerCase()} ml-2`}>{status === "WAITING_SHOP_ACTION" ? "Shop Action" : s}</div>
                            </div></div></div>
                            <div><div>Time</div><div>{moment(created_at * 1000).format('HH:mm DD MMM')}</div></div>
                        </div>
                    </div>

                </div>
            })}

            <Pagination
                currentPage={currentPage}
                totalCount={data.length}
                pageSize={SIZE}
                onPageChange={setCurrentPage}
            />

        </div>
    );
};

export default MobileProducts;
